import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { ScrollService } from './scroll.service';

export const Ng1ScrollModule = angular
  .module('control-room.shared.services.scroll', [])
  .factory('crScrollService', downgradeInjectable(ScrollService));
